import { Restaurant } from '../type';
import preval from 'preval.macro';
import { foods } from './food';

type InternalRestaurant = {
  name: string;
  near: string;
  distance: number;
  address: string;
  image_url: string;
  contact: string;
  foods: string;
};

export const internalRestaurants: Record<string, InternalRestaurant> = preval`
  const fs = require('fs');
  const json = fs.readFileSync(__dirname + '/../../data/restaurant.json', 'utf8');
  const object = JSON.parse(json);
  const convertInternal = (rawRestaurants) => {
    return Object.fromEntries(Object.entries(rawRestaurants).map((restaurantEntry) => [restaurantEntry[0], {
      name: restaurantEntry[1]['음식점'],
      near: '중문',
      address: restaurantEntry[1]['위치(도로명)'],
      distance: parseInt(restaurantEntry[1]['거리']),
      image_url: restaurantEntry[1]['URL'],
      contact: restaurantEntry[1]['전화번호'],
      foods: restaurantEntry[1]['음식목록']
    }]));
  };
  module.exports = convertInternal(object);
`;

export const restaurants: Record<string, Restaurant> = Object.fromEntries(
  Object.entries(internalRestaurants).map((entry) => {
    const foodList = entry[1].foods
      .split(',')
      .map((food) => foods[food.trim()])
      .filter((v) => v);
    let restaurantType = '';
    if (foodList.length > 0 && foodList[0].category.length > 0) {
      restaurantType = foodList[0].category[0].name;
    } else if (foodList.length == 0) {
      console.warn(`Restaurant ${entry[0]} has no foods.`);
    } else {
      console.warn(`Food ${foodList[0].name} has no category.`);
    }
    const restaurant: Restaurant = {
      name: entry[1].name,
      type: restaurantType,
      address: entry[1].address,
      near: '중문',
      distance: entry[1].distance,
      foods: foodList,
    };
    if (entry[1].image_url.trim()) restaurant.image_url = entry[1].image_url;
    if (entry[1].contact.trim()) restaurant.contact = entry[1].contact;
    return [entry[0], restaurant];
  }),
);

/*
{
아키라: {
  name: '아키라',
  type: '일식',
  near: '중문',
  distance: 52,
  image_url: '/example.png',
  link: 'https://example.com',
  foods: Array<Food>(foods['카레']),
},
};
*/
